






























helpers = require '../../helpers.coffee'

view_model =
  components:
    filters: require('./filters.vue')

  props: ['list_item_options', 'filter_options', 'options']

  data: ->
    flows: []
    filters: {}
    loading: false
    next_page: 1
    selected_flow: {}
    default_options:
      show_everybodys_flows: false

  methods:
    loadFlows: ->
      return if @loading || !@next_page
      @loading = true
      filters = if @default_options.show_everybodys_flows then @filters else @mergeCurrentUserFilterIfSeller(@filters)
      @flow_resource.index @loadSuccess, Loader.off, params: {q: filters, page: @next_page}

    loadSuccess: (resources) ->
      @loading = false
      @next_page = resources.meta.next_page
      @flows = @flows.concat(resources.flows)
      @subscribeToFlowCreationChannel()

    flowsEmpty: ->
      jQuery.isEmptyObject @flows

    updateFlow: (data) ->
      Loader.on()
      @flow_resource.update @updateFlowSuccess, Loader.off, data.attr

    updateFlowSuccess: (resources) ->
      @updateFlowList resources.flow
      Loader.off()

    updateFlowList: (flow) ->
      index = @flows.findIndex flow.id

      if index > -1
        Vue.set @flows, index, flow
      else
        @flows.push flow

    filter: (filters) ->
      @filters = filters
      @flows = []
      @next_page = 1
      @loadFlows()

    openDestroyFlowConfirmationModal: (flow) ->
      @selected_flow = flow
      EventsBus.$emit('confirm-modal-show', id: 'destroy-flow-confirmation-modal')

    destroyFlow: ->
      @flow_resource.destroy(@destroyFlowSuccess, @unknownError, @selected_flow)

    destroyFlowSuccess: ->
      intercomTitle = this.$t('flows.label.removeDialogTitle')
      intercomDescription = this.$t('flows.label.removeDialogDescription')
      @flows.remove(@selected_flow.id)
      alertify.success(this.$t('flows.feedback.removeSuccess'))
      IntercomCtrl.trackEvent(intercomTitle, { intercomDescription: location.href + '/' +@selected_flow.id })

    mergeDefaultOptions: ->
      @default_options = Object.assign({}, @default_options, @options)

    refreshFlow: (data) ->
      index = 0
      for flow, idx in @flows
        index = idx if flow.id == data.id
      return unless index >= 0
      Vue.set(@flows, index, new Flow(data))

    subscribeToFlowCreationChannel: ->
      @removeSubscription()
      @subscription = ActionCable.cable.subscriptions.create { channel: 'FlowCreationChannel', user_id: @user_id },
        received: (data) =>
          @refreshFlow(data)

    removeSubscription: ->
      ActionCable.cable.subscriptions.remove(@subscription) if @subscription

  computed:
    destroy_confirm_modal_message: ->
      this.$t('flows.label.removeConfirm', { name: @selected_flow.name })

  created: ->
    @mergeDefaultOptions()
    @flow_resource = new FlowsResource Session.current_company.id
    @setFiltersFromQueryParams()
    @loadFlows()

  beforeDestroy: ->
    @removeSubscription()

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/list.vue